/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Settings_NavInputs */

const en_task_settings_nav = /** @type {(inputs: Task_Settings_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task settings`)
};

const pt_br2_task_settings_nav = /** @type {(inputs: Task_Settings_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atividades`)
};

/**
* | output |
* | --- |
* | "Task settings" |
*
* @param {Task_Settings_NavInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_settings_nav = /** @type {((inputs?: Task_Settings_NavInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Settings_NavInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_settings_nav(inputs)
	return pt_br2_task_settings_nav(inputs)
});